import {
  flatten,
  forEachObjIndexed,
  has,
  is,
  isNil,
  keys,
  map,
  reject,
  uniq,
  values,
} from "ramda";

import { ReactError } from "utils/errors";

const indexedObjectToArray = (indexedObject) => {
  const maxIndex = parseInt(
    keys(indexedObject).reduce((a, b) => Math.max(a, b)),
    10,
  );

  const array = Array(maxIndex + 1);

  forEachObjIndexed((value, index) => {
    array[parseInt(index, 10)] = value;
  }, indexedObject);

  return array;
};

const isIndexedObject = (object) =>
  !Array.isArray(object) && parseInt(keys(object)[0], 10) >= 0;

const transformErrors = (errors) => {
  if (Array.isArray(errors)) {
    if (errors.length === 0) {
      return null;
    }

    if (is(String, errors[0])) {
      return errors[0];
    }

    if (has("text", errors[0])) {
      return errors[0].text;
    }

    throw new ReactError(`Unrecognized error format`, { errors });
  }

  return map((messages) => {
    if (isIndexedObject(messages)) {
      return indexedObjectToArray(messages).map(transformErrors);
    }

    return transformErrors(messages);
  }, errors);
};

const onlyMessages = (errors) => {
  if (errors instanceof Error) {
    return errors.message;
  }

  if (is(Array, errors)) {
    return reject(isNil, map(onlyMessages, errors));
  }

  if (is(String, errors)) {
    return errors;
  }

  if (is(Object, errors)) {
    return map(onlyMessages, values(errors));
  }

  return null;
};

const messages = (errors) => {
  return uniq(flatten(onlyMessages(errors)));
};

export { messages, transformErrors };
